<template>
  <div class="section-wrap" id="qualifications-modal-template">
    <div class="loop-tbl" v-for="(qualification, index) in qualifications" :key="index">
      <div class="multi-item-title mt-40" v-if="index === 0">
        <h3 class="section-title ">보유 자격증/면허증</h3>
        <div class="check-util">
          <div class="check-wrap">
            <input type="checkbox" id="chk1" v-model="qualificationUseYn" true-value="N" false-value="Y" title="chk1 선택">
            <label for="chk1"><span>보유 사항 없음</span></label>
          </div>
          <button type="button" class="btn btn-line-box btn-sm" @click="reset(0)">
            <i class="ico ico-refresh"></i>
            입력항목 초기화
          </button>
        </div>
      </div>
      <div class="multi-item-title mt-40" v-else>
        <h3 class="section-title ">추가정보{{ index }}</h3>
        <div class="check-util">
          <button type="button" class="btn btn-line-box btn-sm" @click="reset(index)">
            <i class="ico ico-refresh"></i>
            입력항목 초기화
          </button>
          <button type="button" class="btn btn-line-box btn-sm" @click="del(index)">
            <i class="ico ico-trash"></i>
            삭제하기
          </button>
        </div>
      </div>
      <div class="table-wrap">
        <table class="table-body-only">
          <caption>보유 자격증/면허증 테이블</caption>
          <colgroup class="pc-cell">
            <col style="width: 160px;" />
            <col />
          </colgroup>
          <colgroup class="mo-cell">
            <col style="width: 88px;" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">자격증/<br class="mo-only">면허증</th>
              <td>
                <div class="input-area mo-size wid400">
                  <input type="text" placeholder="입력하세요" v-model="qualification.quanm" :disabled="isDisabled" title="자격증/면허증" @input="limitBytes($event, qualification, 'quanm', 100, '자격증/면허증')"/>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">발행처/<br class="mo-only">발행기관</th>
              <td>
                <div class="input-area mo-size wid400">
                  <input type="text" placeholder="입력하세요" v-model="qualification.publicOrg" :disabled="isDisabled" title="발행처/발행기관" @input="limitBytes($event, qualification, 'publicOrg', 200, '발행처/발행기관')"/>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">합격구분</th>
              <td>
                <div class="input-area mo-size wid400">
                  <select title="합격구분 선택" v-model="qualification.passcd" :disabled="isDisabled">
                    <option value="">합격구분 선택</option>
                    <option v-for="passingStep in passingSteps" :key="passingStep.code" :value="passingStep.code">{{ passingStep.name }}</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">취득년도</th>
              <td>
                <div class="input-area mo-size wid400">
                  <input type="text" placeholder="예) 2023" v-model="qualification.getdate" :disabled="isDisabled" maxlength="4" @input="validateYear($event, index)" pattern="[0-9]{4}" title="취득년도"/>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <span>※ 입력하신 자격증/면허증 보유사항은 구직활동 시 증빙자료를 요청할 수 있습니다.</span>
    </div>
    <!-- Add Resume Card -->
    <div class="flex flex-direction align-items-center mt-40">
      <button type="button" class="add-resume-icon" @click="add" :disabled="isDisabled">
        <i class="ico ico-plus48"></i>
        <p>추가하기</p>
      </button>
      <p>클릭하여 추가 정보를 입력하실 수 있습니다.</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Axios from 'axios';
import { apiHandler, byteLimitMixin } from './resume-common';

export default({
  name: 'qualifications-modal-template',
  mixins: [byteLimitMixin],
  props: ['qualificationsModal', 'indbankNo', 'passingSteps'],
  data() {
    return {
      qualifications: [],
      qualificationUseYn: 'Y',
      qualification: {
        quanm: '',
        publicOrg: '',
        passcd: '',
        getdate: '',
      },
      isDisabled: false,
    };
  },
  watch: {
    qualificationsModal: {
      handler(newVal) {
        if (newVal) {
          if (this.indbankNo) {
            this.getQualifications();
            this.getBasic();
          } else {
            this.add();
          }
        }
      },
      immediate: true,
    },
    qualificationUseYn: {
      handler(newVal) {
        this.isDisabled = (newVal === 'N');
      },
      immediate: true,
    },
  },
  methods: {
    getQualifications() {
      Axios.get(`/api/idb/${this.indbankNo}/qualifications`).then((response) => {
        if (response.data.success === 'R') {
          this.qualifications = response.data.data.map((qualification) => {
            const newQualification = { ...qualification };
            if (!newQualification.passcd) {
              newQualification.passcd = '';
            }
            return newQualification;
          });
          if (this.qualifications.length === 0) this.add();
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    getBasic() {
      Axios.get(`/api/idb/${this.indbankNo}/basic`).then((response) => {
        if (response.data.success === 'R') {
          this.qualificationUseYn = response.data.data.qualificationUseYn;
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    updateQualifications() {
      if (this.vaildCheck() && confirm('저장하시겠습니까?')) {
        let qualificationsParams = [];
        if (this.qualificationUseYn === 'Y') {
          qualificationsParams = [...this.qualifications];
        }
        Axios.post(`/api/idb/${this.indbankNo}/qualifications`, { qualificationUseYn: this.qualificationUseYn, qualifications: qualificationsParams }).then((response) => {
          apiHandler.handleSaveSuccess(response, (res) => {
            // 완성도 업데이트 (올바른 경로로 접근)
            if (res.data && res.data.data.completionRate !== undefined) {
              this.$emit('update:CompletionRate', res.data.data.completionRate);
            }
          });
        }).catch((e) => {
          apiHandler.handleError(e);
        });
      }
    },
    vaildCheck() {
      // 취득년도 유효성 검증
      const currentYear = new Date().getFullYear();

      for (let i = 0; i < this.qualifications.length; i++) {
        const getdate = this.qualifications[i].getdate;

        // 취득년도가 입력된 경우에만 검증
        if (getdate && getdate.trim() !== '') {
          // 4자리 숫자가 아닌 경우
          if (!/^\d{4}$/.test(getdate)) {
            alert('취득년도는 4자리 연도로 입력해주세요.');
            return false;
          }

          const year = parseInt(getdate);
          // 유효한 연도 범위가 아닌 경우
          if (year < 1900 || year > currentYear) {
            alert(`취득년도는 1900년부터 ${currentYear}년까지 입력 가능합니다.`);
            return false;
          }
        }
      }

      return true;
    },
    add() {
      // 각 자격증 항목마다 독립적인 새 객체 생성
      const newQualificationItem = {
        quanm: '',
        publicOrg: '',
        passcd: '',
        getdate: '',
      };
      this.qualifications.push(newQualificationItem);
    },
    reset(index) {
      const message = '입력하신 내용을 초기화하시겠습니까?';

      if (confirm(message)) {
        // 해당 인덱스에 독립적인 새 객체 생성
        const resetQualificationItem = {
          quanm: '',
          publicOrg: '',
          passcd: '',
          getdate: '',
        };
        Vue.set(this.qualifications, index, resetQualificationItem);
      }
    },
    del(index) {
      if (confirm('해당 추가정보를 삭제 하시겠습니까?')) {
        this.qualifications.splice(index, 1);
      }
    },
    validateYear(event, index) {
      const value = event.target.value;
      // 숫자가 아닌 문자 제거
      const numericValue = value.replace(/[^0-9]/g, '');

      // 4자리 제한
      if (numericValue.length <= 4) {
        this.qualifications[index].getdate = numericValue;
      } else {
        // 4자리를 초과하는 경우 원래 값 유지
        event.target.value = this.qualifications[index].getdate;
      }
    },
  },
});
</script>



// WEBPACK FOOTER //
// Qualifications.vue?0b11f335